/* eslint-disable */
export default {
  noActiveCalls: 'No hay llamadas activas',
  noRecords: 'No hay resultados.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
